import { useAllInstancesQuery as e, useAttachChannelMutation as t, useCreateInstanceMutation as n, useDeleteInstanceMutation as r, useDetachChannelMutation as i, useInstanceQuery as a, useInstancesQuery as o, useRenameInstanceMutation as s, useSetInstanceEnabledMutation as c } from "@frontends/data-access-spg-instances";
import { useAllRetentionRulesQuery as l, useRetentionHealthQuery as u } from "@frontends/data-access-spg-retention-rules";
import { DsAlert as d, DsBadge as f, DsButton as p, DsCard as m, DsDialog as h, DsIconButton as g, DsLink as _, DsRadio as v, DsRadioGroup as y, DsSwitch as b, DsTabBar as ee, DsTabBarItem as x, dsToast as S } from "@frontends/ds";
import { DecisionsTable as C } from "@frontends/feature-spg-decisions";
import { ParticipantsTable as w } from "@frontends/feature-spg-participants";
import { HealthAlerts as T, HealthBadges as E } from "@frontends/feature-spg-retention-rules";
import { Page as D, PageHeader as O, PropertyList as k, RowList as A, RowListItem as j } from "@frontends/ui-spg-layout";
import { getApiErrorMessage as M } from "@frontends/util-api-errors";
import { useState as N } from "react";
import { useTranslation as P } from "react-i18next";
import { useLocation as te, useNavigate as F, useParams as ne, useSearchParams as I } from "react-router";
import { UiKitAlertDialog as re } from "@frontends/ui-kit";
import { Fragment as L, jsx as R, jsxs as z } from "react/jsx-runtime";
import { useForm as B } from "@frontends/form";
import { useAllBotsQuery as V } from "@frontends/data-access-spg-bots";
import { useAllChannelsQuery as H } from "@frontends/data-access-spg-channels";
import { useAllEntryFlowsQuery as U } from "@frontends/data-access-spg-entry-flows";
import { useDataTable as W } from "@frontends/data-table";
//#region src/lib/constants.ts
var G = "feature-spg-instances";
//#endregion
//#region src/lib/components/DeleteInstanceDialog.tsx
function K({ instance: e, onClose: t, onDeleted: n }) {
	let { t: i } = P(G), a = r(), o = async () => {
		try {
			await a.mutateAsync(e.id), S.success({ title: i("delete.done", { name: e.name }) }), n();
		} catch (t) {
			S.danger({
				title: i("delete.failed", { name: e.name }),
				description: M(t, i("delete.failedFallback"))
			});
		}
	};
	return /* @__PURE__ */ R(re, {
		open: !0,
		onOpenChange: (e) => !e && t(),
		title: i("delete.title", { name: e.name }),
		description: i("delete.description"),
		confirmLabel: i("delete.confirm"),
		cancelLabel: i("delete.cancel"),
		onConfirm: () => void o()
	});
}
//#endregion
//#region src/lib/components/AddChannelDialog.tsx
function q({ instance: e, lookups: n, platform: r, onClose: i }) {
	let { t: a } = P(G), o = t(), s = n.channels.filter((e) => e.platform === r && !n.takenChannelIds.has(e.id)), c = B({
		fields: { channelId: {
			type: "select",
			label: a("channels.channel"),
			description: s.length === 0 ? a("channels.noFreeChannels") : void 0,
			options: s.map((e) => ({
				value: e.id,
				label: e.name
			})),
			validators: ["required"]
		} },
		submitLabel: a("channels.submit"),
		fieldMap: { channel_id: "channelId" },
		onSubmit: async (t) => {
			let n = s.find((e) => e.id === t.channelId);
			await o.mutateAsync({
				id: e.id,
				channelId: String(t.channelId)
			}), S.success({ title: a("channels.attached", { name: n?.name ?? "" }) }), i();
		}
	});
	return /* @__PURE__ */ R(h, {
		title: a("channels.add"),
		isOpen: !0,
		onOpenChange: (e) => !e && i(),
		children: /* @__PURE__ */ R(c.Form, { className: "flex flex-col gap-4" })
	});
}
//#endregion
//#region src/lib/components/InstanceChannels.tsx
var J = "text-textTertiary hover:text-textDangerPrimary focus-visible:text-textDangerPrimary";
function Y({ instance: e, lookups: t, platform: n }) {
	let { t: r } = P(G), a = i(), [o, s] = N(!1), c = e.channels.length === 1, l = async (t, n) => {
		try {
			await a.mutateAsync({
				id: e.id,
				channelId: t
			}), S.success({ title: r("channels.detached", { name: n }) });
		} catch (e) {
			S.danger({
				title: r("channels.detachFailed", { name: n }),
				description: M(e, r("channels.failedFallback"))
			});
		}
	};
	return /* @__PURE__ */ z(m, {
		title: r("columns.channels"),
		action: /* @__PURE__ */ R(p, {
			variant: "secondary",
			size: "sm",
			iconStart: "plus",
			onPress: () => s(!0),
			children: r("channels.add")
		}),
		children: [/* @__PURE__ */ R(A, { children: e.channels.map((e) => /* @__PURE__ */ z(j, {
			action: /* @__PURE__ */ R(g, {
				name: "trash-2",
				size: "sm",
				className: J,
				isDisabled: c,
				"aria-label": r("channels.detachOf", { name: e.title }),
				tooltip: r(c ? "channels.lastChannel" : "channels.detach"),
				onPress: () => void l(e.id, e.title)
			}),
			children: [/* @__PURE__ */ R("span", {
				className: "truncate text-textPrimary",
				children: e.title
			}), /* @__PURE__ */ R("span", {
				className: "truncate font-mono text-sm text-textSecondary",
				children: e.externalId
			})]
		}, e.id)) }), o && /* @__PURE__ */ R(q, {
			instance: e,
			lookups: t,
			platform: n,
			onClose: () => s(!1)
		})]
	});
}
//#endregion
//#region src/lib/components/InstanceRules.tsx
function ie({ instanceId: e, getRuleHref: t, getNewRuleHref: n }) {
	let { t: r } = P(G), i = F(), a = (l().data ?? []).filter((t) => t.instanceId === e).sort((e, t) => t.priority - e.priority || e.name.localeCompare(t.name));
	return /* @__PURE__ */ R(m, {
		title: r("rules.title"),
		action: /* @__PURE__ */ R(p, {
			variant: "secondary",
			size: "sm",
			iconStart: "plus",
			onPress: () => void i(n(e)),
			children: r("rules.add")
		}),
		children: a.length === 0 ? /* @__PURE__ */ R("p", {
			className: "text-base text-textSecondary",
			children: r("rules.none")
		}) : /* @__PURE__ */ R(A, { children: a.map((e) => /* @__PURE__ */ R(j, {
			action: /* @__PURE__ */ R(f, {
				size: "sm",
				variant: e.enabled ? "success" : "neutral",
				children: r(e.enabled ? "status.enabled" : "status.disabled")
			}),
			children: /* @__PURE__ */ R(_, {
				href: t(e.id),
				variant: "secondary",
				className: "self-start",
				children: e.name
			})
		}, e.id)) })
	});
}
//#endregion
//#region src/lib/components/RenameInstanceDialog.tsx
function ae({ instance: e, onClose: t }) {
	let { t: n } = P(G), r = s(), i = B({
		fields: { name: {
			type: "text",
			label: n("rename.name"),
			defaultValue: e.name,
			validators: ["required"]
		} },
		submitLabel: n("rename.submit"),
		onSubmit: async (i) => {
			let a = String(i.name).trim();
			await r.mutateAsync({
				id: e.id,
				name: a
			}), S.success({ title: n("rename.done", { name: a }) }), t();
		}
	});
	return /* @__PURE__ */ R(h, {
		title: n("rename.title"),
		isOpen: !0,
		onOpenChange: (e) => !e && t(),
		children: /* @__PURE__ */ R(i.Form, { className: "flex flex-col gap-4" })
	});
}
//#endregion
//#region src/lib/hooks/useLookups.ts
function X() {
	let t = V().data ?? [], n = H().data ?? [], r = U().data ?? [], i = e().data ?? [];
	return {
		bots: t,
		botsById: new Map(t.map((e) => [e.id, e])),
		channels: n,
		entryFlowNames: new Map(r.map((e) => [e.id, e.name])),
		entryFlows: r,
		takenBotIds: new Set(i.map((e) => e.botId)),
		takenChannelIds: new Set(i.flatMap((e) => e.channels.map((e) => e.id)))
	};
}
//#endregion
//#region src/lib/pages/InstancePage.tsx
var Z = "overview", Q = "participants", $ = "activity";
function oe({ backHref: e, getEntryFlowHref: t, getNewRuleHref: n, getParticipantHref: r, getRuleHref: i }) {
	let { t: o } = P(G), { id: s = "" } = ne(), c = a(s), f = X(), m = F(), [h, g] = N(null), _ = () => g(null), [v] = I(), { pathname: y } = te(), b = (u().data ?? []).filter((e) => e.instanceId === s), S = new Map((l().data ?? []).map((e) => [e.id, e.name])), E = v.get("tab") ?? Z, k = (e) => e === Z ? y : `${y}?tab=${e}`;
	return /* @__PURE__ */ z(D, { children: [
		/* @__PURE__ */ R(O, {
			trail: [{
				href: e,
				label: o("view.back")
			}],
			title: c.data?.name ?? "…",
			actions: c.data && /* @__PURE__ */ z(L, { children: [
				/* @__PURE__ */ R(se, { instance: c.data }),
				/* @__PURE__ */ R(p, {
					variant: "secondary",
					iconStart: "pencil",
					onPress: () => g("rename"),
					children: o("rename.open")
				}),
				/* @__PURE__ */ R(p, {
					variant: "destructive",
					iconStart: "trash-2",
					onPress: () => g("delete"),
					children: o("delete.open")
				})
			] })
		}),
		c.isPending && /* @__PURE__ */ R("p", {
			className: "text-base text-textSecondary",
			children: o("view.loading")
		}),
		c.isError && /* @__PURE__ */ R(d, {
			variant: "danger",
			title: o("view.loadFailed"),
			description: M(c.error, o("view.loadFailedDetail")),
			actionLabel: o("view.retry"),
			onAction: () => void c.refetch()
		}),
		c.data && /* @__PURE__ */ z(L, { children: [
			/* @__PURE__ */ R(ee, {
				"aria-label": o("tabs.label"),
				selectedKey: E,
				keyboardActivation: "manual",
				children: [
					Z,
					Q,
					$
				].map((e) => /* @__PURE__ */ R(x, {
					id: e,
					href: k(e),
					children: o(`tabs.${e}`)
				}, e))
			}),
			E === Z && /* @__PURE__ */ z("div", {
				className: "flex flex-col gap-6",
				children: [
					!c.data.enabled && /* @__PURE__ */ R(d, {
						variant: "warning",
						description: o("view.disabledHint")
					}),
					/* @__PURE__ */ R(T, {
						items: b,
						rules: {
							getHref: i,
							names: S
						}
					}),
					/* @__PURE__ */ z("div", {
						className: "grid items-start gap-6 lg:grid-cols-2",
						children: [/* @__PURE__ */ z("div", {
							className: "flex min-w-0 flex-col gap-6",
							children: [/* @__PURE__ */ R(ce, {
								instance: c.data,
								lookups: f,
								getEntryFlowHref: t
							}), /* @__PURE__ */ R(Y, {
								instance: c.data,
								lookups: f,
								platform: f.botsById.get(c.data.botId)?.platform
							})]
						}), /* @__PURE__ */ R(ie, {
							instanceId: c.data.id,
							getRuleHref: i,
							getNewRuleHref: n
						})]
					})
				]
			}),
			E === Q && /* @__PURE__ */ R(w, {
				instanceId: c.data.id,
				getParticipantHref: (e) => r(s, e)
			}),
			E === $ && /* @__PURE__ */ z("div", {
				className: "flex flex-col gap-4",
				children: [/* @__PURE__ */ R("p", {
					className: "text-base text-textSecondary",
					children: o("activity.hint")
				}), /* @__PURE__ */ R(C, {
					scope: { instanceId: c.data.id },
					getRuleHref: i
				})]
			})
		] }),
		h === "rename" && c.data && /* @__PURE__ */ R(ae, {
			instance: c.data,
			onClose: _
		}),
		h === "delete" && c.data && /* @__PURE__ */ R(K, {
			instance: c.data,
			onClose: _,
			onDeleted: () => void m(e, { replace: !0 })
		})
	] });
}
function se({ instance: e }) {
	let { t } = P(G), n = c(), r = async (r) => {
		try {
			await n.mutateAsync({
				id: e.id,
				enabled: r
			}), S.success({ title: t(r ? "view.enabledDone" : "view.disabledDone", { name: e.name }) });
		} catch (e) {
			S.danger({
				title: t("view.toggleFailed"),
				description: M(e, t("view.loadFailedDetail"))
			});
		}
	};
	return /* @__PURE__ */ R(b, {
		isSelected: e.enabled,
		isDisabled: n.isPending,
		onChange: (e) => void r(e),
		children: t(e.enabled ? "status.enabled" : "status.disabled")
	});
}
function ce({ instance: e, lookups: t, getEntryFlowHref: n }) {
	let { t: r } = P(G), i = t.botsById.get(e.botId);
	return /* @__PURE__ */ R(m, {
		title: r("view.general"),
		children: /* @__PURE__ */ R(k, { items: [{
			label: r("columns.bot"),
			value: /* @__PURE__ */ z("span", {
				className: "flex items-center gap-2",
				children: [i && /* @__PURE__ */ R(f, {
					size: "sm",
					children: r(`platforms.${i.platform}`)
				}), i?.name ?? r("unknown")]
			})
		}, {
			label: r("columns.entryFlow"),
			value: /* @__PURE__ */ R(_, {
				href: n(e.entryFlowId),
				variant: "secondary",
				children: t.entryFlowNames.get(e.entryFlowId) ?? r("unknown")
			})
		}] })
	});
}
//#endregion
//#region ../../shared/model-spg-core/src/platform.ts
var le = [
	"telegram",
	"whatsapp",
	"discord"
];
//#endregion
//#region src/lib/components/CreateInstanceDialog.tsx
function ue({ isOpen: e, lookups: t, onOpenChange: n }) {
	let { t: r } = P(G), [i, a] = N("telegram");
	return /* @__PURE__ */ R(h, {
		title: r("create.title"),
		isOpen: e,
		onOpenChange: n,
		children: /* @__PURE__ */ z("div", {
			className: "flex flex-col gap-4",
			children: [/* @__PURE__ */ R(y, {
				label: r("create.platform"),
				orientation: "horizontal",
				value: i,
				onChange: (e) => a(e),
				children: le.map((e) => /* @__PURE__ */ R(v, {
					value: e,
					children: r(`platforms.${e}`)
				}, e))
			}), /* @__PURE__ */ R(de, {
				lookups: t,
				platform: i,
				onCreated: () => n(!1)
			}, i)]
		})
	});
}
function de({ lookups: e, platform: t, onCreated: r }) {
	let { t: i } = P(G), a = n(), o = e.bots.filter((n) => n.platform === t && !e.takenBotIds.has(n.id)), s = e.channels.filter((n) => n.platform === t && !e.takenChannelIds.has(n.id));
	return /* @__PURE__ */ R(B({
		fields: {
			name: {
				type: "text",
				label: i("create.name"),
				validators: ["required"]
			},
			botId: {
				type: "select",
				label: i("create.bot"),
				description: o.length === 0 ? i("create.noFreeBots") : void 0,
				options: o.map((e) => ({
					value: e.id,
					label: e.name
				})),
				validators: ["required"]
			},
			entryFlowId: {
				type: "select",
				label: i("create.entryFlow"),
				options: e.entryFlows.map((e) => ({
					value: e.id,
					label: e.name
				})),
				validators: ["required"]
			},
			channelIds: {
				type: "checkboxGroup",
				label: i("create.channels"),
				description: s.length === 0 ? i("create.noFreeChannels") : i("create.channelsHint"),
				options: s.map((e) => ({
					value: e.id,
					label: e.name
				})),
				validators: ["required"]
			}
		},
		submitLabel: i("create.submit"),
		fieldMap: {
			bot_id: "botId",
			entry_flow_id: "entryFlowId",
			channel_ids: "channelIds"
		},
		onSubmit: async (e) => {
			let t = await a.mutateAsync({
				name: String(e.name).trim(),
				botId: String(e.botId),
				entryFlowId: String(e.entryFlowId),
				channelIds: e.channelIds
			});
			S.success({ title: i("create.created", { name: t.name }) }), r();
		}
	}).Form, { className: "flex flex-col gap-4" });
}
//#endregion
//#region src/lib/pages/InstancesPage.tsx
function fe({ getInstanceHref: e }) {
	let { t } = P(G), n = I(), r = X(), [i, a] = N(!1), s = u().data ?? [], c = [
		{
			id: "name",
			label: t("columns.name"),
			isRowHeader: !0,
			isSortable: !0,
			width: 220,
			cell: (e) => e.name
		},
		{
			id: "bot",
			label: t("columns.bot"),
			width: 260,
			cell: (e) => {
				let n = r.botsById.get(e.botId);
				return n ? /* @__PURE__ */ z("div", {
					className: "flex items-center gap-2",
					children: [/* @__PURE__ */ R(f, {
						size: "sm",
						children: t(`platforms.${n.platform}`)
					}), /* @__PURE__ */ R("span", { children: n.name })]
				}) : /* @__PURE__ */ R("span", {
					className: "text-textTertiary",
					children: t("unknown")
				});
			}
		},
		{
			id: "entryFlow",
			label: t("columns.entryFlow"),
			width: 220,
			cell: (e) => r.entryFlowNames.get(e.entryFlowId) ?? t("unknown")
		},
		{
			id: "channels",
			label: t("columns.channels"),
			cell: (e) => /* @__PURE__ */ R("span", {
				className: "text-textSecondary",
				children: e.channels.map((e) => e.title).join(", ")
			})
		},
		{
			id: "health",
			label: t("columns.health"),
			width: 220,
			cell: (e) => /* @__PURE__ */ R(E, { items: s.filter((t) => t.instanceId === e.id) })
		},
		{
			id: "status",
			label: t("columns.status"),
			width: 120,
			skeleton: "pill",
			cell: (e) => /* @__PURE__ */ R(f, {
				size: "sm",
				variant: e.enabled ? "success" : "neutral",
				children: t(e.enabled ? "status.enabled" : "status.disabled")
			})
		}
	], l = W({
		"aria-label": t("table.label"),
		columns: c,
		defaultSort: {
			by: "name",
			order: "asc"
		},
		getRowKey: (e) => e.id,
		getRowHref: (t) => e(t.id),
		searchParams: n,
		filters: { query: {
			type: "search",
			label: t("filters.search"),
			defaultValue: ""
		} }
	}), d = o(l.requestParams, l.filters);
	return /* @__PURE__ */ z(D, { children: [
		/* @__PURE__ */ R(O, { title: t("title") }),
		/* @__PURE__ */ z(l.Frame, { children: [/* @__PURE__ */ R(l.Toolbar, { children: /* @__PURE__ */ R(p, {
			iconStart: "plus",
			onPress: () => a(!0),
			children: t("create.open")
		}) }), /* @__PURE__ */ R(l.Table, {
			query: d,
			emptyState: {
				icon: "layers",
				title: t("empty.title"),
				description: t("empty.description"),
				actionLabel: t("create.open"),
				onAction: () => a(!0)
			}
		})] }),
		/* @__PURE__ */ R(ue, {
			isOpen: i,
			lookups: r,
			onOpenChange: a
		})
	] });
}
//#endregion
export { G as FEATURE_SPG_INSTANCES_NAMESPACE, oe as InstancePage, fe as InstancesPage };
